import React from 'react'

/**
 * @caveat Handler should always be wrapped in a callback.
 */
const useOnClickOutside = (
  ref: React.RefObject<HTMLElement>,
  handler: (ev: MouseEvent) => void
) => {
  React.useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendant elements
      if (!ref.current || ref.current.contains(event.target)) {
        return
      }
      handler(event)
    }

    document.addEventListener('mousedown', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
    }
  }, [ref, handler])
}

export default useOnClickOutside
